import React, { Component } from 'react';
import { Button, Input, Select, message, InputNumber } from 'antd';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import HighSearchInput from '../../common/HighSearchInput';

const InputGroup = Input.Group;
const { Option } = Select;

class Filter extends Component {
    state = {
        stageList: [],
        contractTypeList: [],
        searchParams: {
            oper: "GE",
        },
    }

    componentDidMount() {
        this.loadTypeConfigureList();
    }

    loadTypeConfigureList = () => {
        const options = {
            method: 'POST',
            url: API_URL.common.typeConfigureList,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { stageList, contractTypeList } = res;
                this.setState({
                    stageList,
                    contractTypeList,
                });
            }
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pmOptions, pmLeaderOptions, searchParams } = this.state;
        const { pmId, pmLeaderId } = searchParams;
        if (pmId) {
            const isExist = pmOptions.some(item => item.value == pmId);
            if (!isExist) {
                message.warning('请选择正确的PM');
                return;
            }
        }
        if (pmLeaderId) {
            const isExist = pmLeaderOptions.some(item => item.value == pmLeaderId);
            if (!isExist) {
                message.warning('请选择正确的PM主管');
                return;
            }
        }
        this.props.search({...searchParams});
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    export = () => {
        this.props.export();
    }

    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        if (key === 'stageIds') {
            searchParams[key] = value ? value.join(',') : undefined;
        }
        this.setState({ searchParams });
    }

    handleHighSearchInputChange = (id, options, idName, optionsName) => {
        const { searchParams } = this.state;
        searchParams[idName] = id;
        this.setState({
            searchParams,
            [optionsName]: options,
        });
    }

    back = ()=> {
        this.props.back();
    }

    render() {
        const {
            stageList,
            contractTypeList,
            searchParams: {
                stageIds,
                oper,
            }
        } = this.state;
        const { curRole } = sessionStorage;
        const stageOption = stageList.map(d => <Option key={String(d.typeConfigureId)}>{d.typeValue}</Option>)
        const contractTypeOption = contractTypeList.map(d => <Option key={String(d.typeConfigureId)}>{d.typeValue}</Option>)
        return (
            <div className="filter-bar">
                <div className="form-item">
                    <label htmlFor="" className="ui-label">项目编号</label>
                    <Input
                        placeholder="请输入"
                        style={{ width: 100 }}
                        onKeyPress={this.enterSearch}
                        onChange={e => this.handleInputChange(e, 'investigationCode')}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">项目简称</label>
                    <Input
                        placeholder="请输入"
                        onKeyPress={this.enterSearch}
                        onChange={e => this.handleInputChange(e, 'investigationName')}
                    />
                </div>
                <div className="form-item" style={{height: 30}}>
                    <label htmlFor="" className="ui-label">项目阶段</label>                       
                    <Select
                        mode="multiple"
                        filterOption={false}
                        placeholder="请选择"
                        style={{ width: 130 }}
                        className="multiple-stage"
                        value={stageIds ? stageIds.split(',') : []}
                        onChange={value => this.handleSelectChange(value, 'stageIds')}
                    >
                        {stageOption}
                    </Select>                                                                              
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">JDE主项目号</label>
                    <Input
                        placeholder="请输入"
                        style={{ width: 100 }}
                        onKeyPress={this.enterSearch}
                        onChange={e => this.handleInputChange(e, 'mainCode')}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">计收入确认方式</label>                                               
                    <Select
                        placeholder="请选择"
                        allowClear={true}
                        style={{ width: 80 }}
                        onChange={value => this.handleSelectChange(value, 'contractTypeId')}
                    >
                        {contractTypeOption}
                    </Select>                                                                        
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">PM</label>
                    <HighSearchInput
                        name='user'
                        keyword='keyword'
                        style={{ width: 162 }}
                        params={{ limit: 20 }}
                        placeholder="输入姓名/工号检索"
                        url={API_URL.sumtotal.queryAllInvestigationPm}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode' }}
                        onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'pmId', 'pmOptions')}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">PM主管</label>
                    <HighSearchInput
                        name='user'
                        keyword='keyword'
                        style={{ width: 162 }}
                        params={{ limit: 20 }}
                        placeholder="输入姓名/工号检索"
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode' }}
                        onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'pmLeaderId', 'pmLeaderOptions')}
                    />
                </div>
                <div className="form-item" >
                    <label className="ui-label">Total1超限情况</label>
                    <InputGroup compact>
                        <Select value={oper} onChange={value => this.handleSelectChange(value, 'oper')} >
                            <Option value="GE">&ge;</Option>
                            <Option value="GT">&gt;</Option>
                            <Option value="LT">&lt;</Option>
                            <Option value="LE">&le;</Option>                           
                        </Select>
                        <InputNumber
                            min={0}
                            precision={2}
                            placeholder="请输入"
                            style={{ width: 110 }}
                            onChange={value => this.handleInputChange(value, 'total1')}
                        />
                    </InputGroup>
                </div>
                <div className="form-item">
                    <label className="ui-label">%</label>
                </div>
                {
                    curRole !== 'PM' &&
                    <div className="form-item">
                        <label className="ui-label">AC自动调整功能</label>
                        <Select
                            placeholder='请选择'
                            style={{ width: 80 }}
                            onChange={value => this.handleSelectChange(value, 'acStatus')}
                        >
                            <Option value="OPEN">已开启</Option>
                            <Option value="CLOSE">已关闭</Option>
                        </Select>
                    </div>
                }
                <div className="form-item">
                    <Button type="primary" onClick={this.back} style={{background:'#62cf96',border:'1px solid #00a854'}}>返回</Button>
                    <Button type="primary" onClick={this.export} >导出</Button>
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/investigation/transfinite/Filter.js